export default "__VITE_ASSET__T$uCVLTJ__"